/*
  Bspoq: keeps paid add-on lines (debossing, gift wrapping) in step with the items they belong to.
  Runs everywhere (cart drawer and cart page). One add-on is charged per item.

  Add-ons are linked to their item with the hidden property _addon_link.
  Older debossing add-ons (added before this change) are matched by their _main_variant_id.

  Safety net: if an item is marked "Gift wrap" but its gift wrapping line has gone missing,
  the gift wrapping line is put back, so wrapping can never reach checkout unpaid.
*/
(function () {
  if (window.pmdAddonSyncInit) return;
  window.pmdAddonSyncInit = true;

  var GIFT_WRAP_VARIANT_ID = 57362480202068;
  var GIFT_WRAP_FLAG = 'Gift wrap';

  var busy = false;
  var runAgain = false;
  var failedLinks = {};

  function isAddon(item) {
    return !!(item.properties && item.properties._is_addon === 'true');
  }

  function isDebossed(item) {
    if (!item.properties) return false;
    return Object.keys(item.properties).some(function (key) {
      var val = item.properties[key];
      return key.charAt(0) !== '_' && val !== null && val !== '';
    });
  }

  function workOutUpdates(cart) {
    var mains = [];
    var addons = [];
    cart.items.forEach(function (item) {
      (isAddon(item) ? addons : mains).push(item);
    });
    if (!addons.length) return null;

    var linkQty = {};
    var legacyQty = {};
    mains.forEach(function (item) {
      var link = item.properties && item.properties._addon_link;
      if (link) {
        linkQty[link] = (linkQty[link] || 0) + item.quantity;
      } else if (isDebossed(item)) {
        var vid = String(item.variant_id);
        legacyQty[vid] = (legacyQty[vid] || 0) + item.quantity;
      }
    });

    var updates = {};
    var changed = false;
    var legacyUsed = {};

    addons.forEach(function (addon) {
      var props = addon.properties || {};
      var target = 0;

      if (props._addon_link) {
        target = linkQty[props._addon_link] || 0;
      } else {
        var parent = String(props._main_variant_id || '');
        if (parent && !legacyUsed[parent]) {
          target = legacyQty[parent] || 0;
          legacyUsed[parent] = true;
        }
      }

      if (addon.quantity !== target) {
        updates[addon.key] = target;
        changed = true;
      }
    });

    return changed ? updates : null;
  }

  // Gift wrapped items whose gift wrapping line is missing
  function workOutMissingGiftWrap(cart) {
    var wrapped = {};
    cart.items.forEach(function (item) {
      if (isAddon(item) && item.variant_id === GIFT_WRAP_VARIANT_ID && item.properties._addon_link) {
        wrapped[item.properties._addon_link] = true;
      }
    });

    var adds = [];
    cart.items.forEach(function (item) {
      if (isAddon(item)) return;
      var props = item.properties || {};
      var link = props._addon_link;
      if (!props[GIFT_WRAP_FLAG] || !link || wrapped[link] || failedLinks[link]) return;
      wrapped[link] = true;
      adds.push({
        id: GIFT_WRAP_VARIANT_ID,
        quantity: item.quantity,
        properties: {
          _is_addon: 'true',
          _main_variant_id: String(item.variant_id),
          _addon_for: item.product_title,
          _addon_link: link
        }
      });
    });
    return adds;
  }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component, cart-drawer-items').forEach(function (el) {
      var id = el.dataset.sectionId || (el.closest('cart-drawer') && el.closest('cart-drawer').dataset.sectionId);
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  async function sync() {
    if (busy) {
      runAgain = true;
      return;
    }
    busy = true;

    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var cart = await fetch(root + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
      if (!cart || !cart.items) return;

      var updates = workOutUpdates(cart);
      var adds = workOutMissingGiftWrap(cart);
      if (!updates && !adds.length) return;

      var ids = sectionIds();
      var withSections = function (body) {
        if (ids.length) {
          body.sections = ids.join(',');
          body.sections_url = window.location.pathname;
        }
        return body;
      };

      var json = null;

      if (updates) {
        json = await post(root + 'cart/update.js', withSections({ updates: updates }));
        if (!json || json.status) return;
      }

      if (adds.length) {
        var added = await post(root + 'cart/add.js', withSections({ items: adds }));
        if (!added || added.status) {
          adds.forEach(function (a) { failedLinks[a.properties._addon_link] = true; });
        } else {
          var fresh = await fetch(root + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
          json = Object.assign({}, fresh, { sections: added.sections });
        }
      }

      if (!json) return;

      json._pmdAddonSync = true;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: json }));

      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = json.item_count;
      });

      if (typeof window.updateCartEmptyStateVisibility === 'function') {
        window.updateCartEmptyStateVisibility(json.item_count);
      }
    } catch (err) {
      console.warn('Add-on sync failed', err);
    } finally {
      busy = false;
      if (runAgain) {
        runAgain = false;
        sync();
      }
    }
  }

  // Quantity changes and removals in the cart drawer or cart page
  document.addEventListener('cart:updated', function (event) {
    if (event && event.detail && event.detail._pmdAddonSync) return;
    sync();
  });

  // Anything else that changes the cart through the theme
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (data && data.source === 'cart-items-component') return;
      sync();
    });
  }

  // Check the cart on every page load, so carts that are already out of step get fixed
  sync();
})();